import { Route, Routes } from 'react-router';
import { Layout } from '@/components/Layout';
import { Company } from '@/pages/Company';
import { Contact } from '@/pages/Contact';
import { Home } from '@/pages/Home';
import { NotFound } from '@/pages/NotFound';
import { Services } from '@/pages/Services';
import { Accessibility } from '@/pages/legal/Accessibility';
import { Cookies } from '@/pages/legal/Cookies';
import { PaymentRefunds } from '@/pages/legal/PaymentRefunds';
import { Privacy } from '@/pages/legal/Privacy';
import { Terms } from '@/pages/legal/Terms';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="company" element={<Company />} />
        <Route path="contact" element={<Contact />} />
        <Route path="payment-and-refunds" element={<PaymentRefunds />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="cookies" element={<Cookies />} />
        <Route path="terms" element={<Terms />} />
        <Route path="accessibility" element={<Accessibility />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
